// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604281456/js/" + chunkId + "." + {"44":"9a18fef8","225":"eb05bd1f","481":"4ef70c62","486":"f22f9bfb","770":"2ebe29c5"}[chunkId] + ".0.40195696627106114.chunk.js";
};